import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { ReconciliationPage } from './_dashboard.inventory.reconciliation'

export const Route = createFileRoute('/_dashboard/inventory/reconciliation/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: ReconciliationIndexPage,
})

function ReconciliationIndexPage() {
  return <ReconciliationPage selectedId={undefined} />
}
